import { render, staticRenderFns } from "./ProjectRouteView.vue?vue&type=template&id=17213f65&scoped=true"
import script from "./ProjectRouteView.vue?vue&type=script&lang=js"
export * from "./ProjectRouteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17213f65",
  null
  
)

export default component.exports